import { render } from "./JointProjects.vue?vue&type=template&id=90fffcee&scoped=true"
import script from "./JointProjects.vue?vue&type=script&lang=js"
export * from "./JointProjects.vue?vue&type=script&lang=js"

import "./JointProjects.vue?vue&type=style&index=0&id=90fffcee&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fffcee"]])

export default __exports__